import { render } from "./LeadgenFormLeadsList.vue?vue&type=template&id=21866174"
import script from "./LeadgenFormLeadsList.vue?vue&type=script&lang=js"
export * from "./LeadgenFormLeadsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/LeadgenFormLeadsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21866174"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21866174', __exports__)) {
    api.reload('21866174', __exports__)
  }
  
  module.hot.accept("./LeadgenFormLeadsList.vue?vue&type=template&id=21866174", () => {
    api.rerender('21866174', render)
  })

}


export default __exports__